export const ACTION_UPDATE_POPUP_CLOSED = 'ACTION_UPDATE_POPUP_CLOSED'

import { UPDATE_POPUP_CLOSED } from '../mutations/country-redirect'

export const actions = {
  [ACTION_UPDATE_POPUP_CLOSED]: async function({ commit }) {
    commit(UPDATE_POPUP_CLOSED)
  },
}
